import apiClient from "./apiClient"
import type { McoEndpointBuilder } from "./apiSlice"
import { ApiTag } from "./util/ApiTag"

const ssoEndpoints = (build: McoEndpointBuilder) => ({
	ssoGetAuthCode: build.query({
		queryFn: apiClient.sso.getAuthCode,
		providesTags: [ApiTag.Tenant, ApiTag.Sso]
	}),
	ssoGetToken: build.query({
		queryFn: apiClient.sso.getToken,
		providesTags: [ApiTag.Tenant, ApiTag.Sso]
	})
})

export default ssoEndpoints
